import { sortReplies } from '@btime/helpers'
import React from 'react'

import { useGroupedRepliesByCategory } from '../../../containers/dynamic/presentationList/categories/_data/groupByCategories'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import PdfDocument from './PdfDocument'
import PdfOptionsFormHandler from '../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Preview from '../../../components/pdf/Preview'
import { useReplies, useServiceOrder } from './_load/ServiceOrderLoader'
import { useChildrenServiceOrders } from './_load/ChildrenServiceOrderLoader'
import OptionsForm from '../../serviceOrders/pdf/options/OptionsForm'
import { useResumeCounters } from '../../serviceOrders/resumeV2/general/_data/counters'

const PageContent = () => {
  const serviceOrder = useServiceOrder()
  const replies = useReplies()
  const categories = useGroupedRepliesByCategory(sortReplies(replies))
  const counters = useResumeCounters(serviceOrder)

  const childrenServiceOrders = useChildrenServiceOrders()

  const props = {
    serviceOrder,
    categories,
    counters,
    childrenServiceOrders
  }

  return (
    <PdfOptionsFormHandler>
      <FlexGrid align="stretch">
        <FlexCol flex={3} invisibleOn="mdd">
          <Preview>
            <PdfDocument {...props} />
          </Preview>
        </FlexCol>

        <FlexCol flex={1}>
          <OptionsForm />
        </FlexCol>
      </FlexGrid>
    </PdfOptionsFormHandler>
  )
}

export default PageContent
